import React from "react";
import {
  AnswerQuestionnary,
  AnswerQuestionnarySelected,
  Letter,
} from "./StyledComponents/Contact.style";
const Answer = ({ letter, answer, handleClick, selected }) => {
  return (
    <>
      {selected ? (
        <AnswerQuestionnarySelected value={letter} onClick={handleClick}>
          <Letter>{letter}. </Letter> {answer}
        </AnswerQuestionnarySelected>
      ) : (
        <AnswerQuestionnary value={letter} onClick={handleClick}>
          <Letter className="letter">{letter}. </Letter> {answer}
        </AnswerQuestionnary>
      )}
    </>
  );
};
export default Answer;
